import { Popover, PopoverOrigin } from "@mui/material";
import { useHistory } from "react-router-dom";
import { SETTING_PAGE_SUBROUTES } from "@/Constants/setting";
import { onLogoutBtnClick } from "@/Utils/authenticate";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import { useStaffPermission } from "@/Hooks/useStaffPermission";
import { LogoutModalProps } from "../../Types";

const LogoutModal = (props: LogoutModalProps) => {
  const history = useHistory();
  const { anchorEl, setAnchorEl } = props;
  const { canManageSettingAndPromo } = useStaffPermission();

  return (
    <Popover
      anchorEl={anchorEl}
      open={!!anchorEl}
      anchorOrigin={
        {
          vertical: "top",
          horizontal: "left",
        } as PopoverOrigin
      }
      transformOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      classes={{
        paper: `!tw-rounded-md !tw-overflow-visible !tw-p-0 !tw-bg-transparent !tw-shadow-none`,
        root: "!tw-static !tw-w-fit !tw-h-fit",
      }}
      onClose={() => setAnchorEl(null)}
      onMouseLeave={() => setAnchorEl(null)}
    >
      <div className="tw-relative !tw-mb-[12px] tw-flex tw-min-w-[157px] -tw-translate-x-[15px] tw-rounded-xl tw-bg-white !tw-shadow-[1px_2px_8px_0px_#00000026]">
        <ArrowDropDown
          className="tw-absolute tw-left-[10px] tw-top-full -tw-translate-y-[45%] tw-text-white"
          fontSize="large"
        />
        <div className="tw-w-[157px] tw-py-[8px]">
          {canManageSettingAndPromo && 
            <div
              className="tw-flex tw-cursor-pointer tw-flex-nowrap tw-items-center tw-text-nowrap tw-px-[18px] tw-py-[6px] tw-font-normal tw-text-[#111C36] hover:tw-bg-[#111C360D]"
              onClick={() => history.push(SETTING_PAGE_SUBROUTES.PROFILE)}
            >
              Profile settings
            </div>
          }
          <div
            className="tw-flex tw-cursor-pointer tw-flex-nowrap tw-items-center tw-text-nowrap tw-px-[18px] tw-py-[6px] tw-font-normal tw-text-[#111C36] hover:tw-bg-[#111C360D]"
            onClick={onLogoutBtnClick}
          >
            Logout
          </div>
        </div>
      </div>
    </Popover>
  );
};

export default LogoutModal;
